import React, { TextField, Grid, Paper, Typography, Button } from '@mui/material';
import { useState, ChangeEvent } from 'react';
import { Collapser } from 'components';
import { ProductsFilterPaneProps } from './ProductFilterPaneProps';

export const ProductFilterPane = ({ filterData, setFilterData }: ProductsFilterPaneProps) => {
	const [isExpanded, setIsExpanded] = useState(false);
	const handleFilterChange = (event: ChangeEvent<HTMLInputElement>) => {
		setFilterData({ ...filterData, [event.target.name]: event.target.value });
	};
	return (
		<Paper sx={{ p: 5 }}>
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={2} alignItems={'center'}>
						<Grid item xs={11}>
							<TextField name='name' label='Name' size='small' fullWidth value={filterData.name} onChange={handleFilterChange} />
						</Grid>
						<Grid item xs={1} textAlign={'center'} alignSelf={'end'}>
							<Button onClick={() => setIsExpanded(!isExpanded)}>
								<Collapser isAdd={false} open={isExpanded} />
							</Button>
						</Grid>
					</Grid>
				</Grid>
				{isExpanded && (
					<>
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={5}>
									<TextField sx={{ width: '100%' }} name='basePriceFrom' label='Price from' size='small' type='number' value={filterData.basePriceFrom} onChange={handleFilterChange} />
								</Grid>
								<Grid item xs={2} textAlign={'center'} alignSelf={'end'}>
									<Typography variant='h4'>-</Typography>
								</Grid>
								<Grid item xs={5}>
									<TextField sx={{ width: '100%' }} name='basePriceTo' label='Price to' size='small' type='number' value={filterData.basePriceTo} onChange={handleFilterChange} />
								</Grid>
							</Grid>
						</Grid>
						<Grid item xs={12}>
							<Grid container>
								<Grid item xs={5}>
									<TextField sx={{ width: '100%' }} name='bonusPointsFrom' label='Bonus points from' size='small' type='number' value={filterData.bonusPointsFrom} onChange={handleFilterChange} />
								</Grid>
								<Grid item xs={2} textAlign={'center'} alignSelf={'end'}>
									<Typography variant='h4'>-</Typography>
								</Grid>
								<Grid item xs={5}>
									<TextField sx={{ width: '100%' }} name='bonusPointsTo' label='Bonus points to' size='small' type='number' value={filterData.bonusPointsTo} onChange={handleFilterChange} />
								</Grid>
							</Grid>
						</Grid>
					</>
				)}
			</Grid>
		</Paper>
	);
}
